/** Bump when a wire-incompatible change is made. Node and viewer send it in `hello`/`join`. */
export const PROTOCOL_VERSION = 2;
//# sourceMappingURL=version.js.map